import CheckpointHoleIconSvg from './checkpointHole.svg?react';

const CheckpointHoleIcon = () => {
    return (
        <CheckpointHoleIconSvg />
    );
};

export default CheckpointHoleIcon;